import { visibilitySlice } from './slice';
export const { update } = visibilitySlice.actions;
